import newborn from "./Figures/Vectors/newborn.svg";
import bottle from "./Figures/Vectors/bottle.svg";
import growth from "./Figures/Vectors/growth.svg";
import certificate from "./Figures/Vectors/certificate.svg";
import evidence1 from "./Figures/Vectors/evidence1.svg";
import record from "./Figures/Vectors/record.svg";
import stethoscope from "./Figures/Vectors/stethoscope.svg";
import vaccine from "./Figures/Vectors/vaccine.svg";

const services = [
  { icon: newborn,     text: "Πλήρη νεογνολογικό έλεγχο/πρόωρα-τελειόμηνα." },
  { icon: bottle,      text: "Προώθηση μητρικού θηλασμού – Συμβουλές διατροφής στη θηλάζουσα μητέρα." },
  { icon: growth,      text: "Αναπτυξιολογικό έλεγχο βρεφών/παιδιών/εφήβων." },
  { icon: vaccine,     text: "Πλήρη εμβολιαστική κάλυψη." },
  { icon: record,      text: "Λήψη ιστορικού, διάγνωση, θεραπεία όλων των λοιμώξεων/παθήσεων που αφορούν την υγεία του νεογνού, του παιδιού και του εφήβου." },
  { icon: stethoscope, text: "Εξειδικευμένη διάγνωση με χρήση όλων των βοηθητικών εργαλείων (τέστ, οξυμετρία, dextro, …)" },
  { icon: certificate, text: "Προληπτική παιδιατρική (check up) – Πιστοποιητικά υγείας." },
  { icon: evidence1,   text: "Evidence based medicine." },
];

const AboutServices = () => {
  return (
    <section className="bg-sky-50/50 py-16" id="about_services">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="animate-fade-up sm:text-3xl text-2xl font-semibold text-gray-900 mb-4">
            Υπηρεσίες
          </h2>
          <p className="animate-fade-up delay-100 lg:w-2/3 mx-auto text-gray-600 leading-relaxed">
            Στόχος του ιατρείου <b>η σωστή</b> και <b>έγκυρη διάγνωση</b>.
            Μέλημά μας η υγεία, <b>η σωστή διατροφή</b> και <b>η καλή ανάπτυξη</b> των μικρών μας φίλων.<br /><br />
            Για το λόγο αυτό σας παρέχουμε:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((service, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-sky-100 p-6 flex flex-col items-center text-center hover:shadow-md hover:-translate-y-1 transition-all duration-200"
            >
              <div className="bg-sky-50 rounded-full p-4 mb-4">
                <img src={service.icon} alt="" className="h-12 w-12" />
              </div>
              <p className="text-gray-700 font-medium leading-relaxed text-sm">
                {service.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutServices;
